<template>
  <div class="columns is-vcentered is-mobile">

    <div class="column border-l">
      <div class="field">
        <b-checkbox v-if="parlay"
                    v-model="parlayBodies"
                    :native-value="`${awaySpreadBody}`">
          {{ awaySpreadBody }}
        </b-checkbox>

        <b-radio v-else
                 v-model="body"
                 :native-value="`${awaySpreadBody}`">
          {{ awaySpreadBody }}
        </b-radio>
      </div>

      <div class="field">
        <b-checkbox v-if="parlay"
                    v-model="parlayBodies"
                    :native-value="`${homeSpreadBody}`">
          {{ homeSpreadBody }}
        </b-checkbox>

        <b-radio v-else
                 v-model="body"
                 :native-value="`${homeSpreadBody}`">
          {{ homeSpreadBody }}
        </b-radio>
      </div>
    </div>

    <div class="column">
      <div class="field">
        <b-checkbox v-if="parlay"
                    v-model="parlayBodies"
                    :native-value="`${overTotalBody}`">
          {{ overTotalBody }}
        </b-checkbox>

        <b-radio v-else
                 v-model="body"
                 :native-value="`${overTotalBody}`">
          {{overTotalBody}}
        </b-radio>
      </div>

      <div class="field">
        <b-checkbox v-if="parlay"
                    v-model="parlayBodies"
                    :native-value="`${underTotalBody}`">
          {{ underTotalBody }}
        </b-checkbox>

        <b-radio v-else
                 v-model="body"
                 :native-value="`${underTotalBody}`">
          {{underTotalBody}}
        </b-radio>
      </div>
    </div>

  </div>
</template>

<script>
import {BCheckbox} from 'buefy/dist/esm/checkbox';

export default {
  components: {
    BCheckbox
  },
  props: {
    game: Object,
    parlay: Boolean
  },
  data() {
    return {
      body: '',
      parlayBodies: [],
      homeTeam:'',
      awayTeam: '',
      dateTime: null,
      type: 'Spread'
    }
  },
  mounted() {
    let { homeTeamNames = {}, awayTeamNames = {}, homeTeamName, awayTeamName, gameDateTime } = this.game;

    this.homeTeam = homeTeamNames.desktop || homeTeamName;
    this.awayTeam = awayTeamNames.desktop || awayTeamName;
    this.dateTime = new Date(gameDateTime || null);
  },
  methods: {
    emitPick: function ({useParlay}) {
      let {body, homeTeam, awayTeam, dateTime, type, parlayBodies} = this;

      this.$emit('picked', {
        id: this.game._id,
        body: useParlay ? JSON.parse(JSON.stringify(parlayBodies)) : body,
        homeTeam,
        awayTeam,
        dateTime,
        type
      });
    }
  },
  computed: {
    homeSpread: function () {
      let { lineBetFormatted = {} } = this.game;
      let { current = {}} = lineBetFormatted;
      let {home} = current;
      let homeFavored = home.match(/(-)/g);
      let homeLine = home.split(' ')[0];

      return homeFavored ? homeLine : this.awaySpread.replace('-', '+');
    },
    awaySpread: function () {
      let { lineBetFormatted = {} } = this.game;
      let { current = {}} = lineBetFormatted;
      let {away} = current;
      let awayFavored = away.match(/(-)/g);
      let awayLine = away.split(' ')[0];

      return awayFavored ? awayLine : this.homeSpread.replace('-', '+');
    },
    total: function () {
      let { lineBetFormatted = {} } = this.game;
      let { current = {}} = lineBetFormatted;
      let {home, away} = current;

      return away.match(/(-)/g) ? home: away;
    },
    homeSpreadBody: function () {
      let {homeTeam, homeSpread} = this;

      return `${homeTeam} ${homeSpread}`
    },
    awaySpreadBody: function () {
      let {awayTeam, awaySpread} = this;

      return `${awayTeam} ${awaySpread}`
    },
    overTotalBody: function () {
      let {total} = this;

      return `OVER ${total}`
    },
    underTotalBody: function () {
      let {total} = this;

      return `UNDER ${total}`
    },
  },
  watch: {
    body: function (newVal) {
      let {underTotalBody, overTotalBody, awaySpreadBody, homeSpreadBody} = this;
      let betTypeMap = {
        [underTotalBody]: 'Total',
        [overTotalBody]: 'Total',
        [awaySpreadBody]: 'Spread',
        [homeSpreadBody]: 'Spread',
      }
      this.type = betTypeMap[newVal] || 'Spread';

      this.emitPick({useParlay: false});
    },
    parlayBodies: function () {
      this.type = 'Parlay';

      this.emitPick({useParlay: true});
    }
  }
}
</script>

<style lang="scss">
@import "~buefy/src/scss/utils/functions";
@import "~buefy/src/scss/utils/variables";
@import "~buefy/src/scss/components/checkbox";
</style>